// extracted by mini-css-extract-plugin
module.exports = {"appLayout":"AppLayout_appLayout__lRBcO","content":"AppLayout_content__pTD0K","container":"AppLayout_container__3oDxA"};